<template>
  <div id="stores">
    <div class="header flex-between">
      <div class="header-text">
        <h1>门店信息管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="search"
          >{{ searchBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="shopMVisible = true"
          >{{ insertBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="iconfont icon-xiugai1"
          @click="handleEdit"
          >{{ modifyBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          @click="removePopup"
          >{{ deleteBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="checkDetail"
          >{{ lookBtnText }}</el-button
        >
        <el-button v-if="jurisdiction.time" @click="timeVisibleBtn"
          >可预约时间管理</el-button
        >
        <el-button v-if="jurisdiction.copy" @click="copyCustVisibleBtn"
        >会员备份管理</el-button
        >
      </div>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除会员确认取消对话框"
        :visible.sync="deleteFormVisible"
        :closeOnClickModal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>门店信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteForm">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 门店管理—创建—选择类型 -->
    <div class="createShop">
      <el-dialog
        title="门店管理—创建—选择类型"
        width="30%"
        :visible.sync="shopMVisible"
      >
        <div style="height: 50px">
          <el-form label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择门店类型">
                  <el-radio-group v-model="xzradio" @change="shopNameChange">
                    <el-radio :label="1">总部门店</el-radio>
                    <el-radio :label="0">普通门店</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nextDialog">下一步</el-button>
          <el-button @click="shopMVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!--总门店---创建弹窗  -->
    <div class="create">
      <el-dialog
        width="35%"
        title="门店管理—总部店创建"
        :visible.sync="createTotalVisible"
        :closeOnClickModal="false"
      >
        <div>
          <div>
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="100px"
              :model="establishTotalForm"
              :rules="totalRules"
              ref="createTotalRefs"
              :hide-required-asterisk="true"
            >
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店编号" prop="shopCode">
                    <el-input v-model="establishTotalForm.shopCode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店名称" prop="shopName">
                    <el-input v-model="establishTotalForm.shopName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="别名">
                    <el-input v-model="establishTotalForm.shopAlias"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="状态">
                    <el-select
                      style="width: 100%"
                      v-model="establishTotalForm.state"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in optionsState"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="省份">
                    <el-select
                      style="width: 100%"
                      v-model="establishTotalForm.stateID"
                      @change="provinceChange"
                    >
                      <el-option
                        v-for="item in provinceData"
                        :key="item.stateID"
                        :value="item.stateID"
                        :label="item.stateName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="城市">
                    <el-select
                      style="width: 100%"
                      v-model="establishTotalForm.cityID"
                    >
                      <el-option
                        v-for="item in cityData"
                        :key="item.cityID"
                        :value="item.cityID"
                        :label="item.cityName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="详细地址">
                    <div class="xuan flex-between">
                      <el-input v-model="establishTotalForm.address"></el-input>
                      <el-button
                        style="
                          margin-left: 5px;
                          background-color: #cccccc;
                          color: #4d4d4d;
                        "
                        size="mini"
                        @click="mapVisibleshow(establishTotalForm.address)"
                        >定位</el-button
                      >
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="经度">
                    <el-input v-model="establishTotalForm.longitude"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="纬度">
                    <el-input v-model="establishTotalForm.latitude"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <div style="height: 350px; border: 2px solid #ccc"></div>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店简介">
                    <el-input
                      type="textarea"
                      :rows="5"
                      v-model="establishTotalForm.shopDescript"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <!-- <el-col :span="24">
                  <el-form-item label="门店简介">
                    <el-input
                      type="textarea"
                      :rows="5"
                      v-model="establishTotalForm.shopDescript"
                    ></el-input>
                  </el-form-item>
                </el-col> -->
                <!-- <el-col :span="24">
                  <el-form-item label="查找门店可见">
                    <el-checkbox
                      v-model="establishTotalForm.show"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店图片">
                    <el-upload
                      class="updelu-image"
                      ref="upload"
                      action="/api/uploadImg"
                      :limit="limitSize"
                      accept="image/*"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUpload"
                      :http-request="getFile"
                    >
                      <img
                        v-if="establishTotalForm.shopImg1"
                        :src="establishTotalForm.shopImg1"
                        class="avatar"
                        @click="removerImage"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row> -->
            </el-form>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createTotal">保 存</el-button>
          <el-button @click="createTotalClose">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!--普通门店---创建弹窗  -->
    <div class="create">
      <el-dialog
        width="52%"
        title="门店管理—普通门店创建"
        :visible.sync="createVisible"
        :closeOnClickModal="false"
      >
        <div>
          <div>
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="110px"
              :model="establishForm"
              :rules="rules"
              ref="createRefs"
              :hide-required-asterisk="true"
            >
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="门店编号" prop="shopCode">
                    <el-input v-model="establishForm.shopCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="门店名称" prop="shopName">
                    <el-input v-model="establishForm.shopName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="别名">
                    <el-input v-model="establishForm.shopAlias"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属区域" prop="regionID">
                    <el-select
                      style="width: 100%"
                      v-model="establishForm.regionID"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in optionsRegion"
                        :key="item.id"
                        :label="item.lable"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="联系电话">
                    <el-input v-model="establishForm.telCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="虚拟号码">
                    <el-input v-model="establishForm.virtualNumber"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="手机号码">
                    <el-input
                      v-model="establishForm.mobile"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="虚拟固话">
                    <el-input v-model="establishForm.virtualPhone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="状态">
                    <el-select
                      style="width: 100%"
                      v-model="establishForm.state"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in optionsState"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店庆日">
                    <!-- <el-input v-model="establishForm.storeDayStr"></el-input> -->
                    <el-date-picker
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                      size="mini"
                      v-model="establishForm.storeDayStr"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="省份">
                    <el-select
                      style="width: 100%"
                      v-model="establishForm.stateID"
                      @change="provinceChange"
                    >
                      <el-option
                        v-for="item in provinceData"
                        :key="item.stateID"
                        :value="item.stateID"
                        :label="item.stateName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="城市">
                    <el-select
                      style="width: 100%"
                      v-model="establishForm.cityID"
                    >
                      <el-option
                        v-for="item in cityData"
                        :key="item.cityID"
                        :value="item.cityID"
                        :label="item.cityName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="详细地址">
                    <div class="xuan flex-between">
                      <el-input v-model="establishForm.address"></el-input>
                      <el-button
                        style="
                          margin-left: 5px;
                          background-color: #cccccc;
                          color: #4d4d4d;
                        "
                        size="mini"
                        @click="mapVisibleshow(establishForm.address)"
                        >定位</el-button
                      >
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="门店介绍">
                    <el-input
                      type="textarea"
                      :rows="1"
                      v-model="establishForm.shopDescript"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">

                <el-col :span="12">
                  <el-form-item label="营业时间">
                    <el-input v-model="saveModifyFrom.openHours"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="是否电商门店">
                    <el-checkbox
                      v-model="establishForm.isOnlineShop"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="礼券不可选门店">
                    <el-checkbox
                      v-model="establishForm.canntCoupons"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="消费不升级门店">
                    <el-checkbox
                      v-model="establishForm.vIPInvalidSale"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="查找门店可见">
                    <el-checkbox
                      v-model="establishForm.show"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="经度">
                    <el-input v-model="establishForm.longitude"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="纬度">
                    <el-input v-model="establishForm.latitude"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item>
                    <div style="height: 350px; border: 2px solid #ccc"></div>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店相片">
                    <div style="height: 350px; border: 2px solid #ccc"></div>
                  </el-form-item>
                </el-col>
              </el-row> -->
            </el-form>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createVisibleSave">保 存</el-button>
          <el-button @click="(createVisible = false), (establishForm = {})"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!--查看弹窗  -->
    <div class="examine">
      <el-dialog
        width="40%"
        title="门店管理-查看"
        :visible.sync="examineVisible"
        :closeOnClickModal="false"
      >
        <div>
          <div>
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="100px"
              :model="lookFormLabelAlign"
              disabled
            >
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="门店编号">
                    <el-input v-model="lookFormLabelAlign.shopCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="门店名称">
                    <el-input v-model="lookFormLabelAlign.shopName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="别名">
                    <el-input v-model="lookFormLabelAlign.shopAlias"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属区域">
                    <el-select
                      style="width: 100%"
                      v-model="lookFormLabelAlign.regionID"
                    >
                      <el-option
                        v-for="item in optionsRegion"
                        :key="item.id"
                        :value="item.id"
                        :label="item.lable"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="联系电话">
                    <el-input v-model="lookFormLabelAlign.telCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="虚拟号码">
                    <el-input
                      v-model="lookFormLabelAlign.virtualNumber"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="手机号码">
                    <el-input v-model="lookFormLabelAlign.mobile"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="虚拟固话">
                    <el-input v-model="lookFormLabelAlign.virtualPhone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="状态">
                    <el-select
                      v-model="lookFormLabelAlign.state"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in lookState"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店庆日">
                    <el-date-picker
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                      v-model="lookFormLabelAlign.storeDay"
                      type="date"
                      placeholder="选择日期时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="省份">
                    <el-select
                      v-model="lookFormLabelAlign.regionID"
                      style="width: 100%"
                      @change="provinceChange"
                    >
                      <el-option
                        v-for="item in provinceData"
                        :key="item.stateID"
                        :value="item.stateID"
                        :label="item.stateName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="城市">
                    <el-select
                      v-model="lookFormLabelAlign.cityID"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in cityData"
                        :key="item.cityID"
                        :value="item.cityID"
                        :label="item.cityName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="详细地址">
                    <div class="xuan flex-between">
                      <el-input v-model="lookFormLabelAlign.address"></el-input>
                      <!-- <el-button
                        style="
                          margin-left: 5px;
                          background-color: #cccccc;
                          color: #4d4d4d;
                        "
                        size="mini"
                        disabled
                        >定位</el-button
                      > -->
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="门店介绍">
                    <el-input
                      v-model="lookFormLabelAlign.shopDescript"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">

                <el-col :span="12">
                  <el-form-item label="营业时间">
                    <el-input v-model="saveModifyFrom.openHours"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="">
                    <el-checkbox-group
                      v-model="lookFormLabelAlign.isOnlineShop"
                    >
                      <el-checkbox
                        label="是否电商门店"
                        name="type"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <el-checkbox-group
                      v-model="lookFormLabelAlign.canntCoupons"
                    >
                      <el-checkbox
                        label="礼券不可选门店"
                        name="type"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="">
                    <el-checkbox
                      label="消费不升级门店"
                      v-model="lookFormLabelAlign.vIPInvalidSale"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <el-checkbox
                      label="查找门店可见"
                      v-model="lookFormLabelAlign.show"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="门店图片">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="lookFormLabelAlign.shopImg1"
                    >
                    </el-image>
                  </el-form-item>
                </el-col>
                <el-col :span="12"> </el-col>
              </el-row> -->
            </el-form>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="examineVisible = false">返 回</el-button>
        </div>
      </el-dialog>
    </div>
    <!--总门店---修改弹窗  -->
    <div class="create">
      <el-dialog
        width="35%"
        title="门店管理—总部店修改"
        :visible.sync="modifyTotalVisible"
        :closeOnClickModal="false"
      >
        <div>
          <div>
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="100px"
              :model="modifyTotalForm"
              ref="modifyTotalRefs"
              :hide-required-asterisk="true"
            >
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店编号" prop="shopCode">
                    <el-input
                      disabled
                      v-model="modifyTotalForm.shopCode"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店名称" prop="shopName">
                    <el-input v-model="modifyTotalForm.shopName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="别名">
                    <el-input v-model="modifyTotalForm.shopAlias"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="状态">
                    <el-select
                      style="width: 100%"
                      v-model="modifyTotalForm.state"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in optionsState"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="省份">
                    <el-select
                      style="width: 100%"
                      v-model="modifyTotalForm.stateID"
                      @change="provinceChange"
                    >
                      <el-option
                        v-for="item in provinceData"
                        :key="item.stateID"
                        :value="item.stateID"
                        :label="item.stateName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="城市">
                    <el-select
                      style="width: 100%"
                      v-model="modifyTotalForm.cityID"
                    >
                      <el-option
                        v-for="item in cityData"
                        :key="item.cityID"
                        :value="item.cityID"
                        :label="item.cityName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="详细地址">
                    <div class="xuan flex-between">
                      <el-input v-model="modifyTotalForm.address"></el-input>
                      <el-button
                        style="
                          margin-left: 5px;
                          background-color: #cccccc;
                          color: #4d4d4d;
                        "
                        size="mini"
                        @click="mapVisibleshow(modifyTotalForm.address)"
                        >定位</el-button
                      >
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="经度">
                    <el-input v-model="modifyTotalForm.longitude"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="纬度">
                    <el-input v-model="modifyTotalForm.latitude"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <div style="height: 350px; border: 2px solid #ccc"></div>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店简介">
                    <el-input
                      type="textarea"
                      :rows="5"
                      v-model="modifyTotalForm.shopDescript"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="查找门店可见">
                    <el-checkbox
                      v-model="modifyTotalForm.show"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="门店图片">
                    <div style="height: 350px; border: 2px solid #ccc">
                      <img src="modifyTotalForm.shopImg1" alt="" />
                    </div>
                  </el-form-item>
                </el-col>
              </el-row> -->
            </el-form>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="zbmodifyqd">保 存</el-button>
          <el-button
            @click="(modifyTotalVisible = false), (modifyTotalForm = {})"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="examine">
      <el-dialog
        width="52%"
        title="门店管理-修改"
        :visible.sync="showVisible"
        :closeOnClickModal="false"
      >
        <div>
          <div>
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="110px"
              :model="saveModifyFrom"
              :rules="rules"
              ref="modifyRefs"
              :hide-required-asterisk="true"
            >
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="门店编号" prop="shopCode">
                    <el-input v-model="saveModifyFrom.shopCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="门店名称" prop="shopName">
                    <el-input v-model="saveModifyFrom.shopName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="别名">
                    <el-input v-model="saveModifyFrom.shopAlias"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属区域" prop="regionID">
                    <el-select
                      style="width: 100%"
                      v-model="saveModifyFrom.regionID"
                    >
                      <el-option
                        v-for="item in optionsRegion"
                        :key="item.id"
                        :label="item.lable"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="联系电话">
                    <el-input v-model="saveModifyFrom.telCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="虚拟号码">
                    <el-input v-model="saveModifyFrom.virtualNumber"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="手机号码" prop="mobile">
                    <el-input v-model="saveModifyFrom.mobile"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="虚拟固话">
                      <el-input v-model="saveModifyFrom.virtualPhone"></el-input>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="状态">
                    <!-- <el-input v-model="saveModifyFrom.state"></el-input> -->
                    <el-select
                      style="width: 100%"
                      v-model="saveModifyFrom.state"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in optionsState"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店庆日">
                    <!-- <el-input v-model="saveModifyFrom.storeDay"></el-input> -->
                    <el-date-picker
                      style="width: 100%"
                      v-model="saveModifyFrom.storeDay"
                      type="date"
                      placeholder="选择日期时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="省份">
                    <el-select
                      style="width: 100%"
                      v-model="saveModifyFrom.province"
                      @change="provinceChange"
                    >
                      <el-option
                        v-for="item in provinceData"
                        :key="item.stateID"
                        :value="item.stateID"
                        :label="item.stateName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="城市">
                    <el-select
                      style="width: 100%"
                      v-model="saveModifyFrom.city"
                    >
                      <el-option
                        v-for="item in cityData"
                        :key="item.cityID"
                        :value="item.cityID"
                        :label="item.cityName_cn"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="详细地址">
                    <div class="xuan flex-between">
                      <el-input v-model="saveModifyFrom.address"></el-input>
                      <el-button
                        style="
                          margin-left: 5px;
                          background-color: #cccccc;
                          color: #4d4d4d;
                        "
                        class="fff"
                        @click="mapVisibleshow(saveModifyFrom.address)"
                        size="mini"
                        >定位</el-button
                      >
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="门店介绍">
                    <el-input v-model="saveModifyFrom.shopDescript"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="纬度">
                    <el-input v-model="saveModifyFrom.latitude"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="经度">
                    <el-input v-model="saveModifyFrom.longitude"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row :gutter="50">

                <el-col :span="12">
                  <el-form-item label="营业时间">
                    <el-input v-model="saveModifyFrom.openHours"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="是否电商门店">
                    <el-checkbox
                      v-model="saveModifyFrom.isOnlineShop"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="礼券不可选门店">
                    <el-checkbox
                      v-model="saveModifyFrom.canntCoupons"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="消费不升级门店">
                    <el-checkbox
                      v-model="saveModifyFrom.vIPInvalidSale"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="查找门店可见">
                    <el-checkbox
                      v-model="saveModifyFrom.show"
                      style="margin-top: 6px"
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <!-- <el-col :span="12">
                  <el-form-item label="门店图片">
                    <el-upload
                      class="avatar-uploader"
                      :action="uploadUrl"
                      :headers="headersObj"
                      :on-success="handleAvatarSuccess"
                      :show-file-list="false"
                      list-type="picture-card"
                      :before-upload="beforeAvatarUpload"
                    >
                      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col> -->
                <!-- <el-col :span="12">
                  <el-form-item label="门店类型" prop="shopType">
                    <el-select v-model="saveModifyFrom.shopType">
                      <el-option
                        v-for="item in shopType"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
              </el-row>
            </el-form>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleEditSave">保 存</el-button>
          <el-button @click="handleEditCencel">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 可预约时间管理弹窗 -->
    <div class="anticipate">
      <el-dialog
        width="40%"
        title="门店可预约时间管理-查看"
        :visible.sync="timeVisible"
        :closeOnClickModal="false"
      >
        <div>
          <el-card>
            <el-row :gutter="50">
              <el-col :span="12">
                <!-- <div>门店可预约时间管理-查看</div> -->
              </el-col>
              <el-col :span="12">
                <el-button @click="createAnticipateVisible = true"
                  >创建</el-button
                >
              </el-col>
            </el-row>
          </el-card>
          <el-card>
            <el-form :model="multipleSelection">
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="店铺代码">
                    <el-input
                      v-model="multipleSelection.shopCode"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店铺名称">
                    <el-input
                      v-model="multipleSelection.shopName"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-table
                  height="350"
                  :data="appointmentForm"
                  border
                  style="width: 100%"
                >
                  <el-table-column width="40" type="index"></el-table-column>
                  <el-table-column width="93">
                    <template slot-scope="scope">
                      <el-button @click="modifyAnticipateBtn(scope.row)"
                        >修改</el-button
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="availableDateStr"
                    label="可预约日期"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column label="可预约时间段">
                    <template slot-scope="scope">
                      {{ scope.row.timeLines + "" }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-dialog>
    </div>
    <!-- 预约时间创建弹窗 -->
    <div class="anticipate">
      <el-dialog
        width="40%"
        title="门店可预约时间管理-创建"
        :visible.sync="createAnticipateVisible"
        :closeOnClickModal="false"
      >
        <div>
          <el-card>
            <el-form :model="multipleSelection">
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="店铺代码">
                    <el-input
                      v-model="multipleSelection.shopCode"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店铺名称">
                    <el-input
                      v-model="multipleSelection.shopName"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="auto"
            :model="createAppointmentForm"
            ref="timeFormRef"
            inline-message
            :hide-required-asterisk="true"
          >
            <el-card style="margin-top: 5px">
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item
                    label="日期:"
                    prop="availableDate"
                    :rules="[
                      {
                        type: 'date',
                        required: true,
                        message: '请选择日期',
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="createAppointmentForm.availableDate"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50" style="margin-top: 10px">
                <el-col :span="24">
                  <el-form-item label="可预约时间段:">
                    <el-transfer
                      :titles="['可选择', '已选择']"
                      v-model="createAppointmentForm.appointTime"
                      :right-default-checked="dataxg"
                      :props="{
                        key: 'userDefineID',
                        label: 'description_CN',
                      }"
                      :data="data"
                      @change="changeTime"
                    >
                    </el-transfer>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="timeCreateSave">保 存</el-button>
          <el-button @click="createAnticipateVisible = false">{{
            cancelButtonText
          }}</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 预约时间修改弹窗 -->
    <div class="anticipate">
      <el-dialog
        width="40%"
        title="门店可预约时间管理-修改"
        :visible.sync="modifyAnticipateVisible"
        :closeOnClickModal="false"
      >
        <div>
          <el-card>
            <el-form :model="multipleSelection">
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="店铺代码">
                    <el-input
                      v-model="multipleSelection.shopCode"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店铺名称">
                    <el-input
                      v-model="multipleSelection.shopName"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="auto"
            :model="modifyForm"
          >
            <el-card style="margin-top: 5px">
              <el-row :gutter="50">
                <el-col :span="24">
                  <el-form-item label="日期:">
                    <el-date-picker
                      v-model="modifyForm.availableDateStr"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50" style="margin-top: 10px">
                <el-col :span="24">
                  <el-form-item label="可预约时间段:">
                    <el-transfer
                      :titles="['可选择', '已选择']"
                      v-model="modifyForm.appointTime"
                      :props="{
                        key: 'userDefineID',
                        label: 'description_CN',
                      }"
                      :data="data"
                      @change="changeTime"
                    >
                    </el-transfer>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="timeModifySave">{{ confirmButtonText }}</el-button>
          <el-button @click="modifyAnticipateVisible = false">{{
            cancelButtonText
          }}</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 会员备份 -->
    <div class="anticipate">
      <el-dialog
          width="40%"
          title="备份会员管理"
          :visible.sync="createCopyCustVisible"
          :closeOnClickModal="false"
      >
        <div>
          <el-card>
            <el-row :gutter="50">
              <el-col :span="12">
              </el-col>
              <el-col :span="12">
                <el-button @click="copyData"
                >备份</el-button
                >
                <el-button  @click="exportCopyData"
                >导出</el-button
                >
                <el-button
                    @click="(downloadShow = true), getDownladList()"
                >下载</el-button
                >
              </el-col>
            </el-row>
          </el-card>
          <el-card>
            <el-form :model="multipleSelection">
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-form-item label="店铺代码">
                    <el-input
                        v-model="multipleSelection.shopCode"
                        disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店铺名称">
                    <el-input
                        v-model="multipleSelection.shopName"
                        disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-table
                    height="350"
                    :data="custForm"
                    border
                    style="width: 100%"
                >
                  <el-table-column width="40">
                  <template slot-scope="scope">
                    <el-radio
                        style="margin-left: 10px"
                        :label="scope.$index"
                        v-model="radiovalue1"
                        @change.native="handleSelectionCustChange(scope.row)"
                    >&nbsp;</el-radio
                    >
                  </template>
                </el-table-column>
                  <el-table-column width="40" type="index"></el-table-column>

                  <el-table-column
                      prop="shopCode"
                      label="备份门店"
                      width="80"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="remark"
                      label="备注"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="createTime"
                      label="备份时间"
                      >
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-dialog>
    </div>


    <div>
      <el-card>
        <div class="searchform">
          <el-form :model="totalShop">
            <el-row :gutter="10">
              <el-col :span="1.5">
                <el-form-item label="总部门店"></el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="店铺代码">
                  <el-input
                    style="width: 75%"
                    v-model="totalShop.shopCode"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="店铺名称">
                  <el-input
                    style="width: 60%"
                    v-model="totalShop.shopName"
                    disabled
                  ></el-input>
                  <el-button style="margin-left: 10px" @click="zbmodify"
                    >修改</el-button
                  >
                </el-form-item>
              </el-col>
              <el-col :span="12"></el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <el-card shadow="never">
      <div class="searchform">
        <el-form :model="config" size="small" label-width="180px">
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item label="区域">
                <el-select style="width: 100%" v-model="config.regionID">
                  <el-option
                    v-for="item in optionsRegionsy"
                    :key="item.id"
                    :value="item.id"
                    :label="item.lable"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="门店">
                <el-select
                  style="width: 100%"
                  v-model="config.shopID"
                  filterable
                  @blur="Selecteee"
                >
                  <el-option
                    v-for="item in optionsShop"
                    :key="item.shopID"
                    :label="item.shopCode"
                    :value="item.shopID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select style="width: 100%" v-model="config.state">
                  <el-option
                    v-for="item in optionsStatesy"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" class="centercard">
      <el-table
        size="small"
        :height="520"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
      >
        <el-table-column width="50">
          <template slot-scope="scope">
            <el-radio
              style="margin-left: 10px"
              :label="scope.$index"
              v-model="radio"
              @change.native="handleSelectionChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="shopCode" label="门店编号"> </el-table-column>
        <el-table-column prop="shopName" label="门店名称"> </el-table-column>
        <!-- <el-table-column prop="shopAlias" label="别名"> </el-table-column> -->
        <el-table-column prop="regionName" label="区域"></el-table-column>
        <el-table-column prop="province" label="省份"> </el-table-column>
        <el-table-column prop="city" label="城市"> </el-table-column>
        <el-table-column prop="address" label="详细地址"></el-table-column>
        <!-- <el-table-column prop="longitude" label="经度"> </el-table-column> -->
        <!-- <el-table-column prop="latitude" label="纬度"> </el-table-column> -->
        <el-table-column prop="telCode" label="联系电话"> </el-table-column>
        <el-table-column prop="mobile" label="手机号码"></el-table-column>
        <el-table-column prop="virtualNumber" label="虚拟号码"></el-table-column>
        <el-table-column prop="virtualPhone" label="虚拟固话"></el-table-column>
        <!-- <el-table-column prop="openHours" label=" 营业时间" width="160">
          <template slot-scope="scope">
              {{scope.row.openHours | dateFormat}}
          </template>
        </el-table-column> -->
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.state == 0
                ? "正常营业"
                : scope.row.state == 1
                ? "已撤店"
                : "暂闭店"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="isOnlineShop" label="是否电商门店">
          <template slot-scope="scope">
            {{
              !!scope.row.isOnlineShop == true
                ? "是"
                : !!scope.row.isOnlineShop == false
                ? "否"
                : "否"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="canntCoupons" label="礼券不可选门店">
          <template slot-scope="scope">
            {{
              !!scope.row.canntCoupons == true
                ? "是"
                : !!scope.row.canntCoupons == false
                ? "否"
                : "否"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="vIPInvalidSale" label="消费不升级门店">
          <template slot-scope="scope">
            {{
              !!scope.row.vIPInvalidSale == true
                ? "是"
                : !!scope.row.vIPInvalidSale == false
                ? "否"
                : "否"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="show" label="查找门店可见">
          <template slot-scope="scope">
            {{
              !!scope.row.show == true
                ? "是"
                : !!scope.row.show == false
                ? "否"
                : "否"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="storeDay" label="店庆日" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.storeDay !== null">
              {{ scope.row.storeDay | dateFormat }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="shopDescript" label="门店简介"></el-table-column> -->
        <el-table-column
          prop="createUserName"
          label="创建人员"
        ></el-table-column>
        <el-table-column prop="createTimeStr" label="创建时间" width="150">
        </el-table-column>
        <el-table-column
          prop="updateUserName"
          label="最后修改人"
        ></el-table-column>
        <el-table-column
          width="150"
          prop="updateTimeStr"
          label="最后修改时间"
        ></el-table-column>
      </el-table>
      <el-alert
        v-if="isMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
    <BaiduMapWorld
      ref="baiduMap"
      :mapVisible="mapVisible"
      v-on:mapLocationClose="mapLocationClose"
      v-on:mapLocationSave="mapLocationSave"
    ></BaiduMapWorld>
    <!-- 导出弹窗 -->
    <div class="delete">
      <el-dialog
          :close-on-click-modal="false"
          width="20%"
          title="提示"
          :visible.sync="copyTipShow"
      >
        <div>
          <p  style=" font-size: 14px; font-weight: 700">
            <i class="iconfont icon-jingshi" ></i>
            是否确定备份会员数据?
          </p>

          <el-form >
            <el-row>
              <el-input v-model="remark"
                        type="textarea"
                        placeholder="请输入备注信息"
                        rows="5">
              </el-input>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="copyCustSave">确 定</el-button>
          <el-button @click="copyTipShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
          :close-on-click-modal="false"
          width="20%"
          title="导出会员备份数据表"
          :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
                class="iconfont icon-jingshi"
                style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>会员备份数据表?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
        append-to-body
        width="50%"
        :visible.sync="downloadShow"
        title="下载文件"
    >
      <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="downloadData"
          tooltip-effect="dark"
          style="width: 100%"
      >
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
            prop="startTime"
            label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
                icon="el-icon-download"
                v-if="scope.row.isComplate"
                @click="download(scope.row.downloadUrl)"
            >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getcpyNo,
  // checkMobile,
  //  checkEmail,
  dateTimes,
} from "@/utils/auth";
import { baiduAK } from "@/utils/constant";

import BaiduMapWorld from "@/components/BaiduMapWorld/index.vue";
import {
  // countryApi,
  provinceApi,
  cityApi,
  definedQueryApi,
} from "@/api/region"; //省份
import {addCustcopymainApi, exportCustcopymainApi, selectCustcopymainApi, shopselectAppointTimeApi} from "@/api/shop";
import {
  shopListApi,
  shopDeleteApi,
  queryRegionApi,
  shopInsertApi,
  shopUpdateApi,
  shopSelectByCodeApi,
  shopSelectByIdApi,
  selectAppointTimeApi,
  insertAppointTimeApi,
  updateAppointTimeApi,
  // uploadImg,
} from "@/api/shop";
import { mapState } from "vuex";
import {reportFormList} from "@/api/reportForm";
export default {
  components: {
    BaiduMapWorld,
  },
  name: "centre",
  data() {
    return {
      mapVisible: false,
      limitSize: 1,
      optionsRegionsy: [],
      // 总部门店修改弹窗
      modifyTotalForm: {},
      modifyTotalVisible: false,
      loading: false,
      xzradio: "",
      radio: "",
      radiovalue1: "",
      imageUrl: "",
      // uploadUrl: "http://113.106.164.103:8080/api/uploadImg",
      uploadUrl: "/api/api/uploadImg",
      headersObj: {
        Authorization: window.localStorage.getItem("token"),
      },
      list: [],
      shopMVisible: false,
      timeVisible: false, // 可预约时间弹窗
      createAnticipateVisible: false, //可预约时间创建弹窗
      modifyAnticipateVisible: false, // 可预约时间修改弹窗
      modifyForm: {
        appointTime: [],
      },
      createCopyCustVisible: false, //复制会员弹窗
      deleteFormVisible: false, //删除弹窗
      multipleSelection: {}, //表单选择的数据
      remark: '',
      examineVisible: false,
      showVisible: false,
      createTotalVisible: false, //总门店
      createVisible: false, // 普通门店
      nextIndex: "", // 下一步id
      labelPosition: "left",
      optionsRegion: [],
      optionsShop: [{ id: "", lable: "全部门店" }], // 门店
      optionsState: [
        {
          value: 0,
          label: "正常营业",
        },
        {
          value: 1,
          label: "已撤店",
        },
        {
          value: 2,
          label: "暂闭店",
        },
      ],
      optionsStatesy: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "正常营业",
        },
        {
          value: 1,
          label: "已撤店",
        },
        {
          value: 2,
          label: "暂闭店",
        },
      ],
      config: {
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        pages: 0,
        total: 0,
        regionID: "",
        shopID: "",
        state: "",
      },
      user: {},
      formLabelAlign: {}, // 查看弹框
      saveModifyFrom: {}, //修改弹窗
      provinceData: [], // 存放省份
      provinceValue: "", // 选择的省份
      cityData: [], // city
      establishTotalForm: {}, //总部门店
      // 总门店验证规则
      totalRules: {
        shopCode: [
          { required: true, message: "请填写门店编号", trigger: "blur" },
        ],
        shopName: [
          { required: true, message: "门店名称内容不能为空", trigger: "blur" },
        ],
      },
      // 创建
      establishForm: {
        cpyNO: getcpyNo(),
        shopType: "",
        shopCode: "",
        shopName: "",
        shopAlias: "",
        regionID: "",
        telCode: "",
        virtualNumber: "",
        virtualPhone: "",
        mobile: "",
        openHours: "",
        state: "",
        storeDayStr: "",
        province: "",
        city: "",
        address: "",
        shopDescript: "",
        latitude: "",
        longitude: "",
        isOnlineShop: false,
        canntCoupons: false,
        shopImg1: "",
        vIPInvalidSale: false,
        show: false,
      },
      address: "", // 定位地址
      rules: {
        shopCode: [
          { required: true, message: "请填写门店编号", trigger: "blur" },
        ],
        regionID: [
          { required: true, message: "选择所属区域", trigger: "change" },
        ],
        shopName: [
          { required: true, message: "请填写门店名称", trigger: "blur" },
        ],
        shopType: [
          { required: true, message: "请选择门店类型", trigger: "change" },
        ],
        // mobile: [
        //   { required: true, message: "请输入手机号", trigger: "blur" },
        //   {
        //     validator: checkMobile,
        //     message: "请输入正确的手机号码",
        //     trigger: "blur",
        //   }
        // ],
      },
      appointmentForm: [],
      custForm: [],
      downloadData: [],
      downloadShow: false,
      exportShow: false,
      copyTipShow: false,
      multipleCopyCustSelection: [], //表单选择的数据
      // 预约创建
      createAppointmentForm: {
        name: "",
        appointTime: [],
        availableDate: "",
      },
      modifyAppointmentForm: [],
      data: [],
      dataxg: [],
      lookFormLabelAlign: {}, //查看弹窗数据
      lookState: [
        {
          value: 0,
          label: "启用",
        },
        {
          value: 1,
          label: "禁用",
        },
      ],
      shopType: [
        // 门店类型
        {
          value: 0,
          label: "门店",
        },
        {
          value: 1,
          label: "公司",
        },
      ],
      pages: 0, // 页码数
      count: 1,
      tableData: [],
      totalShop: {}, //列表总部门店
      shopidcs: {
        appointmentID: "",
      },
      shoparr: [],
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        look: false,
        delete: false,
        time: false,
        copy: false,
      },
    };
  },
  computed: {
    isMore() {
      return this.config.pageNo >= this.config.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    ...mapState([
      "searchBtnText",
      "insertBtnText",
      "modifyBtnText",
      "deleteBtnText",
      "lookBtnText",
      "confirmButtonText",
      "cancelButtonText",
    ]),
  },
  created() {
    this.searchList();
    this.searchListRes();
    this.shopList();
    let Stores = JSON.parse(localStorage.getItem("Stores"));
    console.log(Stores);
    for (let i = 0; i < Stores.length; i++) {
      if (Stores[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Stores[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Stores[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (Stores[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (Stores[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (Stores[i].menuName == "可预约时间管理") {
        this.jurisdiction.time = true;
        continue;
      }
      if (Stores[i].menuName == "会员备份管理") {
        this.jurisdiction.copy = true;
        continue;
      }
    }
  },
  mounted() {},
  methods: {
    Selecteee() {
      this.config.shopID = "";
    },
    mapVisibleshow(address) {
      if (address) {
        this.mapVisible = true;
        this.$nextTick(() => {
          this.$refs.baiduMap.Echo(address);
        });
      } else {
        this.$message.info("请先输入详细地址");
      }
    },

    //关闭地图弹窗
    mapLocationClose() {
      this.mapVisible = false;
    },
    mapLocationSave(e) {
      console.log(e);
    },
    // getFile(options) {
    //   //创建上传图片
    //   const formData = new FormData();
    //   formData.append("file", options.file);
    //   uploadImg(formData).then((res) => {
    //     if (res.success == true) {
    //       console.log("成功")
    //       this.establishTotalForm.shopImg1 = UploadPictures + res.data;
    //       console.log(this.establishTotalForm.shopImg1)
    //       this.$message.success("上传成功！");
    //     } else {
    //       console.log("失败")
    //       this.$message.error("上传图片失败!");
    //     }
    //   });
    // },
    // beforeAvatarUpload(file) {
    //   //过滤图片
    //   const isJPG = file.type === "image/jpeg";
    //   // const isLt2M = file.size / 1024 / 1024 < 2;
    //   if (!isJPG) {
    //     this.$message.error("上传图片只能是 JPG 格式!");
    //   }
    //   // if (!isLt2M) {
    //   //   this.$message.error("上传头像图片大小不能超过 2MB!");
    //   // }
    //   // return isJPG && isLt2M;
    //   return isJPG;
    // },
    // removerImage() {
    //   this.establishList.imageUrl = "";
    //   this.$refs.upload.clearFiles();
    // },
    // 总部门店修改事件
    zbmodify() {
      this.zbcxlist();
      this.modifyTotalVisible = true;
    },
    // 总部门店查询事件
    zbcxlist() {
      shopSelectByIdApi({ shopID: this.totalShop.shopID }).then((res) => {
        this.modifyTotalForm = res.data;
        // 省
        this.provinceList();
        // 市
        cityApi({ stateID: this.modifyTotalForm.stateID }).then((res) => {
          this.cityData = res.data;
        });
      });
    },
    // 总部门店修改确定事件
    zbmodifyqd() {
      if (this.modifyTotalForm.address) {
        this.$jsonp("https://api.map.baidu.com/geocoding/v3/", {
          address: this.modifyTotalForm.address,
          output: "json",
          ak: baiduAK,
        })
          .then((json) => {
            // 得到我们想要的内容
            // console.log(json.result.location);
            let modify = {
              shopCode: this.modifyTotalForm.shopCode,
              shopName: this.modifyTotalForm.shopName,
              shopAlias: this.modifyTotalForm.shopAlias,
              regionID: this.modifyTotalForm.regionID,
              shopID: this.modifyTotalForm.shopID,
              stateID: this.modifyTotalForm.stateID,
              cityID: this.modifyTotalForm.cityID,
              state: this.modifyTotalForm.state,
              address: this.modifyTotalForm.address,
              shopDescript: this.modifyTotalForm.shopDescript,
              // show: this.modifyTotalForm.show || false,
              latitude: json.result.location.lat
                ? json.result.location.lat
                : "",
              longitude: json.result.location.lng
                ? json.result.location.lng
                : "",
              // shopImg1: this.modifyTotalForm.shopImg1,
              shopType: 1,
              vIPInvalidSale: 0,
            };
            shopUpdateApi(modify).then((res) => {
              if (res.success !== true) {
                this.$message.error("修改失败!");
                return;
              } else {
                this.$message.success("修改成功");
                // 关闭弹窗
                this.modifyTotalVisible = false;
                // 重新获取首页数据
                this.searchList();
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let modify = {
          shopCode: this.modifyTotalForm.shopCode,
          shopName: this.modifyTotalForm.shopName,
          shopAlias: this.modifyTotalForm.shopAlias,
          regionID: this.modifyTotalForm.regionID,
          shopID: this.modifyTotalForm.shopID,
          stateID: this.modifyTotalForm.stateID,
          cityID: this.modifyTotalForm.cityID,
          state: this.modifyTotalForm.state,
          address: this.modifyTotalForm.address,
          shopDescript: this.modifyTotalForm.shopDescript,
          // show: this.modifyTotalForm.show || false,
          // latitude: this.modifyTotalForm.latitude,
          // longitude: this.modifyTotalForm.longitude,
          // shopImg1: this.modifyTotalForm.shopImg1,
          shopType: 1,
          vIPInvalidSale: 0,
        };
        shopUpdateApi(modify).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改失败!");
            return;
          } else {
            this.$message.success("修改成功");
            // 关闭弹窗
            this.modifyTotalVisible = false;
            // 重新获取首页数据
            this.searchList();
          }
        });
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // time
    async getTime() {
      const { data: res } = await definedQueryApi({
        defineKindID: 34,
      });
      this.data = res;
    },
    // 省份
    provinceList() {
      provinceApi({
        countryID: "CN",
      }).then((res) => {
        this.provinceData = res.data;
      });
    },
    provinceChange(value) {
      this.provinceValue = value;
      this.cityList();
    },
    // 城市
    cityList() {
      cityApi({ stateID: this.provinceValue }).then((res) => {
        this.cityData = res.data;
      });
    },
    // 区域查询
    searchListRes() {
      queryRegionApi({
        regionID: "",
      }).then((res) => {
        this.optionsRegion = res.data;
        if (res.success) {
          this.optionsRegionsy.push({
            id: "",
            lable: "全部区域",
          });
          this.optionsRegionsy.push(...res.data);
        }
        // this.optionsRegion = res.data;
        // this.optionsRegionsy.unshift({
        //   id: "",
        //   lable: "全部",
        // });
      });
    },
    // 所属门店
    // changeSelectCur() {
    //   for (let k in this.optionsRegionsy) {
    //     if (this.config.regionID === this.optionsRegionsy[k].id) {
    //       this.config.shopID = "";
    //       this.optionsShop = [];
    //       this.optionsShop.push({
    //         id: "",
    //         lable: "全部门店",
    //       });
    //       this.optionsShop.push(...this.optionsRegionsy[k].chlidren);
    //     }
    //     //  console.log(this.hehe);
    //   }
    // },
    // 门店查询
    shopList() {
      shopSelectByCodeApi({ shopCode: "" }).then((res) => {
        this.optionsShop = res.data;
        this.optionsShop.unshift({
          shopID: "",
          shopCode: "全部门店",
        });
      });
    },
    // 查询
    search() {
      this.radio=false;
      this.multipleSelection = {};
      this.remark = '';
      this.tableData = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.searchList();
    },
    // 列表数据
    searchList() {
      let queryInfo = {
        cpyNO: getcpyNo(),
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
        regionID: this.config.regionID,
        shopID: this.config.shopID,
        state: this.config.state,
      };
      shopListApi(queryInfo).then((res) => {
        if (res.message == "success") {
          this.totalShop.shopCode = res.shopCode;
          this.totalShop.shopName = res.shopName;
          this.totalShop.shopID = res.shopID;
          if (this.config.pageNo == 1) this.tableData = [];
          this.tableData = this.tableData.concat(res.data.list);
          this.config.pageSize = res.data.pageSize;
          this.config.pages = res.data.pages;
          // this.config.pagesTotal  = res.data.total
          this.loading = false;
        }
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.searchList();
      }, 1000);
    },
    //查看弹窗
    async checkDetail() {
      if (this.multipleSelection == undefined || this.multipleSelection == "")
        return this.$message.info("请选择数据!");
      this.examineVisible = true;
      await shopSelectByIdApi({ shopID: this.multipleSelection.shopID }).then(
        (res) => {
          this.lookFormLabelAlign = res.data;
        }
      );
    },
    // 可预约时间管理
    timeVisibleBtn() {
      if (this.multipleSelection == undefined || this.multipleSelection == "")
        return this.$message.info("请选择数据!");
      this.timeVisible = true;
      selectAppointTimeApi({ shopID: this.multipleSelection.shopID }).then(
        (res) => {
          this.appointmentForm = res.data;
        }
      );
      this.getTime();
    },
    changeTime(val) {
      this.selectTime = val;
    },
    // 可预约时间管理--创建
    timeCreateSave() {
      this.$refs.timeFormRef.validate((vid) => {
        if (vid) {
          let data1 = {
            shopID: this.multipleSelection.shopID,
            appointTime: this.selectTime.join(","),
            availableDate: dateTimes(this.createAppointmentForm.availableDate),
          };
          insertAppointTimeApi(data1).then((res) => {
            if (res.message == "success") {
              this.$message.success("创建成功!");
              this.createAnticipateVisible = false;
              // this.timeVisibleBtn();
              this.appointmentForm = [];
              this.lookFormLabelAlign();
            } else {
              this.$message.error("创建失败!");
            }
          });
        }
      });
    },
    cxshoplist() {
      this.shoparr = [];
      let appointmentID = {
        appointmentID: this.shopidcs.appointmentID,
      };
      shopselectAppointTimeApi(appointmentID).then((res) => {
        this.modifyForm = res.data;
        res.data.appointTimes.map((item) => {
          this.shoparr.push(item.appointTime);
        });
        // this.modifyForm.appointTime = this.shoparr
        this.$set(this.modifyForm, "appointTime", this.shoparr);
      });
    },
    modifyAnticipateBtn(val) {
      this.shopidcs.appointmentID = val.appointmentID;
      this.modifyAnticipateVisible = true;
      this.cxshoplist();
      // this.modifyForm = val;
      // this.modifyForm.appointTime = val.timeLines
      // console.log(this.modifyForm.appointTime);
      // console.log(val, "ddddd");
    },
    // 可预约时间管理--修改
    timeModifySave() {
      let ddd = "";
      if (this.selectTime == undefined) {
        this.selectTime = "";
      } else {
        ddd = this.selectTime.join(",");
      }
      updateAppointTimeApi({
        shopID: this.modifyForm.shopID,
        appointTime: ddd,
        appointmentID: this.modifyForm.appointmentID,
      }).then((res) => {
        if (res.message == "success") {
          this.modifyAnticipateVisible = false;
          this.timeVisibleBtn();
        } else {
          this.$message.error("修改失败!");
        }
      });
    },
    // 修改弹窗
    handleEdit() {
      if (this.multipleSelection == undefined || this.multipleSelection == "") {
        this.$message.info("请选择修改的数据!");
      } else {
        shopSelectByIdApi({ shopID: this.multipleSelection.shopID }).then(
          (res) => {
            this.saveModifyFrom = res.data;
            this.saveModifyFrom.province = res.data.stateID;
            this.saveModifyFrom.city = res.data.cityID;
            this.provinceList();
            // 市
            if (this.saveModifyFrom.stateID !== null) {
              cityApi({ stateID: this.saveModifyFrom.stateID }).then((res) => {
                this.cityData = res.data;
              });
            }
            this.showVisible = true;
          }
        );
      }
    },
    // 普通门店修改
    handleEditSave() {
      this.$refs.modifyRefs.validate((valid) => {
        if (!valid) return;
        if (this.saveModifyFrom.address) {
          this.$jsonp("https://api.map.baidu.com/geocoding/v3/", {
            address: this.saveModifyFrom.address,
            output: "json",
            ak: baiduAK,
          })
            .then((json) => {
              // 得到我们想要的内容
              // console.log(json.result.location);
              shopUpdateApi({
                shopCode: this.saveModifyFrom.shopCode,
                shopName: this.saveModifyFrom.shopName,
                shopAlias: this.saveModifyFrom.shopAlias,
                regionID: this.saveModifyFrom.regionID,
                shopID: this.multipleSelection.shopID,
                telCode: this.saveModifyFrom.telCode,
                virtualNumber: this.saveModifyFrom.virtualNumber,
                virtualPhone: this.saveModifyFrom.virtualPhone,
                mobile: this.saveModifyFrom.mobile,
                openHours: this.saveModifyFrom.openHours,
                state: this.saveModifyFrom.state,
                storeDay: this.saveModifyFrom.storeDay,
                stateID: this.saveModifyFrom.province,
                cityID: this.saveModifyFrom.city,
                address: this.saveModifyFrom.address,
                shopDescript: this.saveModifyFrom.shopDescript,
                show: this.saveModifyFrom.show || false,
                latitude: json.result.location.lat
                  ? json.result.location.lat
                  : "",
                longitude: json.result.location.lng
                  ? json.result.location.lng
                  : "",
                isOnlineShop: this.saveModifyFrom.isOnlineShop,
                canntCoupons: this.saveModifyFrom.canntCoupons,
                // shopImg1: this.saveModifyFrom.shopImg1,
                shopType: 0,
                vIPInvalidSale: this.saveModifyFrom.vIPInvalidSale,
              }).then((res) => {
                if (res.message == "success") {
                  this.$message.success("修改成功!");
                  // 重新获取首页数据
                  this.tableData = [];
                  this.radio = "";
                  this.searchList();
                  this.showVisible = false;
                } else {
                  this.$message.error("修改失败!");
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          shopUpdateApi({
            shopCode: this.saveModifyFrom.shopCode,
            shopName: this.saveModifyFrom.shopName,
            shopAlias: this.saveModifyFrom.shopAlias,
            regionID: this.saveModifyFrom.regionID,
            shopID: this.multipleSelection.shopID,
            telCode: this.saveModifyFrom.telCode,
            virtualNumber: this.saveModifyFrom.virtualNumber,
            virtualPhone: this.saveModifyFrom.virtualPhone,
            mobile: this.saveModifyFrom.mobile,
            openHours: this.saveModifyFrom.openHours,
            state: this.saveModifyFrom.state,
            storeDay: this.saveModifyFrom.storeDay,
            stateID: this.saveModifyFrom.province,
            cityID: this.saveModifyFrom.city,
            address: this.saveModifyFrom.address,
            shopDescript: this.saveModifyFrom.shopDescript,
            show: this.saveModifyFrom.show || false,
            isOnlineShop: this.saveModifyFrom.isOnlineShop,
            canntCoupons: this.saveModifyFrom.canntCoupons,
            // shopImg1: this.saveModifyFrom.shopImg1,
            shopType: 0,
            vIPInvalidSale: this.saveModifyFrom.vIPInvalidSale,
          }).then((res) => {
            if (res.message == "success") {
              this.$message.success("修改成功!");
              // 重新获取首页数据
              this.tableData = [];
              // this.config.pageNo=1
              this.radio = "";
              this.searchList();
              this.showVisible = false;
            } else {
              this.$message.error("修改失败!");
            }
          });
        }
        return;
      });
    },
    handleEditCencel() {
      this.$refs.modifyRefs.resetFields();
      this.showVisible = false;
      // this.saveModifyFrom={}
    },
    // 删除
    removePopup() {
      if (this.multipleSelection == undefined || this.multipleSelection == "") {
        this.$message.info("请选择删除的数据!");
      } else {
        this.deleteFormVisible = true;
      }
    },
    // 删除
    deleteForm() {
      shopDeleteApi({ shopID: this.multipleSelection.shopID }).then((res) => {
        if (res.success) {
          this.deleteFormVisible = false;
          this.$message.success("删除成功!");
          this.count = 1;
          this.tableData = [];
          this.radio = "";
          this.searchList();
        } else {
          this.$message.error(res.message);
        }
      });
      this.searchList();
    },
    // 选中数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // this.lookFormLabelAlign=val
      // console.log(val)
    },

    // 选择门店
    shopNameChange(index) {
      this.nextIndex = index;
      // console.log(index)
    },
    // 下一步
    nextDialog() {
      if (this.nextIndex === 1) {
        this.createTotalVisible = true;
        this.provinceList();
      } else if (this.nextIndex === 0) {
        this.createVisible = true;
        this.provinceList();
      } else {
        this.$message({
          message: "请选择门店!",
          type: "warning",
        });
      }
    },
    // 总门店创建
    createTotal() {
      this.$refs.createTotalRefs.validate((valid) => {
        if (valid) {
          if (this.establishTotalForm.address) {
            this.$jsonp("https://api.map.baidu.com/geocoding/v3/", {
              address: this.establishTotalForm.address,
              output: "json",
              ak: baiduAK,
            })
              .then((json) => {
                // 得到我们想要的内容
                let queryTotal = {
                  cpyNO: getcpyNo(),
                  shopType: 1,
                  shopCode: this.establishTotalForm.shopCode,
                  shopName: this.establishTotalForm.shopName,
                  shopAlias: this.establishTotalForm.shopAlias,
                  state: this.establishTotalForm.state,
                  stateID: this.establishTotalForm.stateID,
                  cityID: this.establishTotalForm.cityID,
                  address: this.establishTotalForm.address,
                  latitude: json.result.location.lat
                    ? json.result.location.lat
                    : "",
                  longitude: json.result.location.lng
                    ? json.result.location.lng
                    : "",
                  shopDescript: this.establishTotalForm.shopDescript,
                  shopImg1: this.establishTotalForm.shopImg1,
                  regionID: this.establishForm.regionID,
                  // show: this.establishTotalForm.show || false,
                  vIPInvalidSale: 0,
                };
                shopInsertApi(queryTotal).then((res) => {
                  if (res.success) {
                    this.$message.success("新增数据成功!");
                    this.createTotalVisible = false;
                    this.config.pageNo = 1;
                    this.searchList();
                    this.establishTotalForm = {};
                  }
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            let queryTotal = {
              cpyNO: getcpyNo(),
              shopType: 1,
              shopCode: this.establishTotalForm.shopCode,
              shopName: this.establishTotalForm.shopName,
              shopAlias: this.establishTotalForm.shopAlias,
              state: this.establishTotalForm.state,
              stateID: this.establishTotalForm.stateID,
              cityID: this.establishTotalForm.cityID,
              address: this.establishTotalForm.address,
              shopDescript: this.establishTotalForm.shopDescript,
              shopImg1: this.establishTotalForm.shopImg1,
              regionID: this.establishForm.regionID,
              // show: this.establishTotalForm.show || false,
              vIPInvalidSale: 0,
            };
            shopInsertApi(queryTotal).then((res) => {
              if (res.success) {
                this.$message.success("新增数据成功!");
                this.createTotalVisible = false;
                this.config.pageNo = 1;
                this.searchList();
                this.establishTotalForm = {};
              }
            });
          }
          return;
        }
      });
    },
    createTotalClose() {
      this.createTotalVisible = false;
      this.establishTotalForm = {};
    },
    // 创建
    createDialog() {
      this.createVisible = true;
      this.provinceList();
    },
    // 普通门店创建
    createVisibleSave() {
      let create = {
        cpyNO: getcpyNo(),
        shopType: 0,
        shopCode: this.establishForm.shopCode,
        shopName: this.establishForm.shopName,
        shopAlias: this.establishForm.shopAlias,
        regionID: this.establishForm.regionID,
        telCode: this.establishForm.telCode,
        virtualNumber: this.establishForm.virtualNumber,
        virtualPhone: this.establishForm.virtualPhone,
        mobile: this.establishForm.mobile,
        openHours: this.establishForm.openHours,
        isOnlineShop: this.establishForm.isOnlineShop,
        storeDayStr: this.establishForm.storeDayStr,
        state: this.establishForm.state,
        canntCoupons: this.establishForm.canntCoupons,
        stateID: this.establishForm.stateID,
        cityID: this.establishForm.cityID,
        address: this.establishForm.address,
        shopDescript: this.establishForm.shopDescript,
        vIPInvalidSale: this.establishForm.vIPInvalidSale,
        show: this.establishForm.show || false,
      };
      console.log(create)
      this.$refs.createRefs.validate((valid) => {
        if (!valid) return;
        shopInsertApi(create).then((res) => {
          if (res.message == "success") {
            this.$message.success("创建成功!");
            this.createVisible = false;
            this.shopMVisible = false;
            this.tableData = [];
            // this.config.pageNo=1
            this.radio = "";
            this.searchList();
            this.establishForm = {};
          } else {
            this.$message.error("创建失败!");
          }
        });
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      this.establishForm.shopImg1 = file.name;
      this.saveModifyFrom.shopImg1 = file.name;
      this.imageUrl = file.name;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 复制客户管理
    copyCustVisibleBtn() {

      if (this.multipleSelection == undefined || this.multipleSelection == ""
          || this.multipleSelection.shopID == undefined)
        return this.$message.info("请选择数据!");
      this.createCopyCustVisible = true;
      selectCustcopymainApi({ shopID: this.multipleSelection.shopID }).then(
          (res) => {
            this.custForm = res.data;
          }
      );
      this.getTime();
    },

    // 备份会员管理--备份
    copyCustSave() {
          let data1 = {
            shopID: this.multipleSelection.shopID,
            remark: this.remark,
          };
      addCustcopymainApi(data1).then((res) => {
            if (res.message == "success") {
              this.$message.success("备份成功!");
              this.copyCustVisibleBtn();
            } else {
              this.$message.error("备份失败!");
            }
        this.copyTipShow = false;
          });


    },
    // 选中数据
    handleSelectionCustChange(val) {
      this.multipleCopyCustSelection = val;

    },
    //获取下载列表数据
    getDownladList() {
      let groupName="门店会员备份报表"+this.multipleSelection.shopCode;
      reportFormList({
        groupName: groupName,
      }).then((response) => {
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 导出
    Export() {

      let data1 = {
        ID: this.multipleCopyCustSelection.ID,
        shopID: this.multipleCopyCustSelection.shopID
      };
      exportCustcopymainApi(data1).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看!");
      });
    },
    exportCopyData(){
      if (this.multipleCopyCustSelection == undefined
          || this.multipleCopyCustSelection == "")
        return this.$message.info("请选择数据!");
      this.exportShow = true;
    },
    copyData(){
      this.remark = '';
      this.copyTipShow = true;
    },
  },
};
</script>
<style lang="scss" scoped>
#stores {
  // height: 860px;
  // height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.searchform {
  height: 50px;
  margin-top: 5px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
.push-button {
  background-color: #e9e7d3;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-form-item {
    margin-top: 10px;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .create {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-dialog__body {
      padding: 20px 60px;
    }
    .el-input__inner {
      //   width: 300px;
    }
    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__active-bar {
      height: 0;
    }
    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .examine {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-dialog__body {
      padding: 20px 60px;
    }
    .el-input__inner {
      //   width: 300px;
    }
    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__active-bar {
      height: 0;
    }
    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 上传图片样式
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }
  // 预约弹窗
  .anticipate {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 20px 0 20px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .createShop {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
  }
  .updelu-image {
    margin-top: 15px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    line-height: 80px;
    width: 80px;
    height: 80px;
    background: #f5f5f5;
    border: 1px solid #cccccc;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
}
</style>
